import { GET, POST } from './Index'

import { PresignatureResponse, PostsignatureRequest, PostsignatureResponse } from '../interfaces'
import bs58 from 'bs58'
import { auth } from './FirebaseInit'

export async function postSignature(
  address: string,
  uuid: string,
  signature: string
): Promise<PostsignatureResponse> {
  return await POST<PostsignatureRequest, PostsignatureResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/postsignature`,
    {
      address,
      uuid,
      signature,
    }
  )
}

export async function preSignature(): Promise<PresignatureResponse> {
  return await GET<PresignatureResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/presignature`
  )
}

export async function signInWithToken(
  publicKey: string,
  signMessage: (message: Uint8Array) => Promise<Uint8Array>
): Promise<void> {
  const resp = await preSignature()
  const msg = resp.message
  const message = new TextEncoder().encode(msg)
  const sig = await signMessage(message)
  const postSigResp = await postSignature(publicKey, resp.uuid, bs58.encode(sig))
  await auth.signInWithCustomToken(postSigResp.token)
}
